import { observer } from 'mobx-react';
import moment from 'moment';
import React, { Component } from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';
import { AddNewTalentColoredIcon, EditIcon, MultiplePagesDeleteIcon, SearchColoredIcon } from '../assets/icons';
import Button from '../components/Button';
import voiceStore from '../stores/voiceStore';
import { PiWarningCircleFill } from "react-icons/pi";
import generalStore from '../stores/generalStore';

const Talents = observer(class Talents extends Component {
  state = {
    showDeleteModal: false,
    talentToDelete: null,
    showSearchInput: false,
    searchQuery: "",  
  };

  componentDidMount() {
    voiceStore.getTalents().then(() => {
    });
  }

  calculateAge = (date) => {
    const birthDate = moment(date);
    const today = moment();
    let age = today.diff(birthDate, 'years'); 
    return isNaN(age) ? "NA" : age;
  };

  toggleDeleteModal = (talent = null) => {
    this.setState({ showDeleteModal: !this.state.showDeleteModal, talentToDelete: talent });
  };

  handleDelete = () => {
    const { talentToDelete } = this.state;
    if (talentToDelete) {
      voiceStore.deleteTalent(talentToDelete.TalentId)
      this.toggleDeleteModal();
    }
  };

  formatData(value) {
    if (value === null || value === "" || value === "null" || value === "undefined" || isNaN(value) || value === "\"\"") {
      return "NA";
    }
    return value;
  }

  handleSearchInputChange = (e) => {
    const query = e.target.value;
    this.setState({ searchQuery: query });
  };

  filteredTalents = () => {
    const { searchQuery } = this.state;
    if (!searchQuery) {
      return voiceStore.talents;
    }
  
    const query = searchQuery.toLowerCase();
  
    return voiceStore.talents.filter((talent) => {
      const talentName = talent.TalentName?.toLowerCase() || '';
      const email = talent.Email?.toLowerCase() || '';
      const age = talent.Age ? this.calculateAge(talent.Age).toString().toLowerCase() : '';
      const accents = talent.Accents?.toLowerCase() || '';
      const mobile = talent.MobileNo?.toLowerCase() || '';
      const social = talent.SocialAccounts?.toLowerCase() || '';
      const nationality = talent.Nationality?.toLowerCase() || '';
      const notes = talent.Notes?.toLowerCase() || '';
      const rating = talent.Rating?.toLowerCase() || '';
      const alias = talent.Alias?.toLowerCase() || '';
      const fee = talent.Fee?.toLowerCase() || '';
  
      return (
        talentName.includes(query) ||
        email.includes(query) ||
        age.includes(query) ||
        accents.includes(query) ||
        mobile.includes(query) ||
        social.includes(query) ||
        nationality.includes(query) ||
        notes.includes(query) ||
        rating.includes(query) ||
        alias.includes(query) ||
        fee.includes(query)
      );
    });
  };
  
  render() {
    const filteredTalents = this.filteredTalents();

    return (
      <div className='bg-[#F2F4F8] h-screen'>
        <div className='flex justify-end mx-6 py-3 gap-3 lg:gap-6'>
          {/* Desktop Button */}
          <Button className="hidden md:flex rounded-md" onClick={() => {
            voiceStore.changeStepperVisible(true);
          }} icon={AddNewTalentColoredIcon} title={"Add New"} />
          {/* Mobile Button */}
          <Button onClick={() => {
            voiceStore.changeStepperVisible(true);
          }} className="flex md:hidden rounded-md" icon={AddNewTalentColoredIcon} />

          {/* Desktop Button */}
          <Button className="hidden md:flex rounded-md" icon={SearchColoredIcon} title={"Search"} onClick={() => this.setState({ showSearchInput: !this.state.showSearchInput })} />
          {/* Mobile Button */}
          <Button className="flex md:hidden rounded-md" icon={SearchColoredIcon} onClick={() => this.setState({ showSearchInput: !this.state.showSearchInput })} />
        </div>

        <div className='flex flex-1 h-full bg-white lg:mx-6'>
          <div className='w-full h-full p-5 box-border'>
            <div className='flex justify-between flex-row items-center py-3 lg:py-6 gap-1'>
              <div className='flex justify-between flex-row items-center gap-1'>
                <span className='font-medium text-base text-black'>Talents</span>
                <span className='font-normal text-xs text-white py-1 px-2 rounded-full lg:rounded-xl bg-[#F89A1F]'>{filteredTalents.length}</span>
              </div>
              {this.state.showSearchInput && (
                <div className="flex justify-center">
                  <input
                    type="text"
                    className="border border-black/60 placeholder-black/80 rounded-md px-3 py-2  max-w-48 lg:w-full lg:max-w-lg"
                    placeholder="Search talents..."
                    value={this.state.searchQuery}
                    onChange={this.handleSearchInputChange}
                  />
                </div>
              )}
            </div>

            <table className='shrink-0 w-full bg-transparent border text-center'>
              <thead>
                <tr className='bg-[#FCD49F] flex flex-1 justify-around'>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex flex-1 justify-center'>Talent's Name</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex-1 justify-center hidden lg:flex'>Email</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex-1 justify-center hidden lg:flex'>Age</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex-1 justify-center hidden lg:flex'>Accents</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex-1 justify-center hidden lg:flex'>Mobile No</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex-1 justify-center hidden lg:flex'>Social</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex flex-1 justify-center'>Action</th>
                </tr>
              </thead>
              <tbody className='flex flex-col flex-1 justify-around '>
                {filteredTalents.length > 0 ? (
                  filteredTalents.map((talent, index) => (
                    <tr key={index} className='flex flex-1 justify-around border-b border-[#DDE1E6] py-2 hover:bg-black/[0.03]'>
                      <td className='flex flex-1 '>
                        <div className='flex flex-1 flex-row gap-x-4 items-center pl-3'>
                          <button onClick={() => {
                            voiceStore.setFavoriteTalent(talent.TalentId);
                          }} className='hidden lg:flex'>
                            {talent?.IsFavorite === "1" ? <FaStar color="#F89A1F" size={15} />
                              : <FaRegStar color='#F89A1F' size={15} />}
                          </button>
                          <div className='flex flex-1 flex-row gap-x-2 items-center'>
                            {
                              talent?.ProfileImgPath ? 
                                <img src={`${process.env.REACT_APP_BASE_URL}/${talent.ProfileImgPath}`} className='w-10 h-10 rounded-full' alt={talent?.TalentName} /> 
                                : 
                                <div className='w-10 h-10 rounded-full bg-gray-200 flex justify-center items-center text-sm text-black/50'>{generalStore.getInitials(talent?.TalentName)}</div>
                            }

                            <button onClick={() => {
                              voiceStore.getTalentById(talent.TalentId).then(() => {
                                voiceStore.setTalentDetailsModalVisible(true);
                              });
                            }} className='flex flex-col items-start'>
                              <span className='font-medium text-sm text-[#21272A] text-left'>{talent?.TalentName}</span>
                              <span className='font-normal text-xs text-[#697077]'>{talent?.Nationality}</span>
                            </button>
                          </div>
                        </div>
                      </td>
                      <td className='flex-1 justify-center items-center font-normal text-sm text-[#130D0D] hidden lg:flex'>{this.formatData(talent?.Email)}</td>
                      <td className='flex-1 justify-center items-center font-normal text-sm text-[#130D0D] hidden lg:flex'>{this.formatData(talent?.Age ? this.calculateAge(talent.Age) : talent?.Age)}</td>
                      <td className='flex-1 justify-center items-center font-normal text-sm text-[#130D0D] hidden lg:flex'>{this.formatData(talent?.Accents)}</td>
                      <td className='flex-1 justify-center items-center font-normal text-sm text-[#130D0D] hidden lg:flex'>{this.formatData(talent?.MobileNo)}</td>
                      <td className='flex-1 justify-center items-center font-normal text-sm text-[#130D0D] hidden lg:flex'>{this.formatData(talent?.SocialAccounts)}</td>

                      <td className='flex flex-1 justify-center items-center '>
                        <div className='flex flex-row gap-6'>
                          <button onClick={() => {
                            voiceStore.getTalentById(talent?.TalentId).then(() => {
                            });
                          }} className='w-5'>
                            <img className='w-5' src={EditIcon} alt="Edit" />
                          </button>
                          <button onClick={() => this.toggleDeleteModal(talent)} className='w-5'>
                            <img className='w-5' src={MultiplePagesDeleteIcon} alt="Delete" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className='flex justify-center py-5'><td>No talents found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Delete Modal */}
        {this.state.showDeleteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white rounded-lg p-5 w-[22rem]">
              <div className='flex flex-row justify-start items-center gap-x-2 mb-4'>
                <PiWarningCircleFill color='#F89A1F' />
                <span className='font-normal text-sm'>Are you sure you want to delete this talent?</span>
              </div>
              <div className="flex justify-end gap-4">
                <button onClick={this.toggleDeleteModal} className='border border-[#D9D9D9] bg-white rounded-sm'>
                  <span className='font-normal text-sm px-3'>No</span>
                </button>
                <button onClick={this.handleDelete} className='border border-black bg-black rounded-sm'>
                  <span className='font-normal text-sm px-3 text-white'>Yes</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
});

export default Talents;
